import { Injectable } from '@angular/core';

const ANDROID_USER_AGENT_REGEX = /android/i;
const IOS_USER_AGENT_REGEX = /iphone|ipad|ipod/i;
const IPAD_OS_DESKTOP_PLATFORM = 'MacIntel';

type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: {
    mobile?: boolean;
  };
};

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectionService {
  private readonly _isMobileOrTablet: boolean;

  constructor() {
    if (typeof window === 'undefined') {
      this._isMobileOrTablet = false;
    } else {
      this._isMobileOrTablet = this.detectMobileOrTablet();
    }
  }

  isMobileOrTablet(): boolean {
    return this._isMobileOrTablet;
  }

  isDesktop(): boolean {
    return !this._isMobileOrTablet;
  }

  private detectMobileOrTablet(): boolean {
    const browserNavigator = globalThis.navigator as
      | NavigatorWithUserAgentData
      | undefined;

    if (!browserNavigator) return false;

    const userAgent = browserNavigator.userAgent ?? '';
    const maxTouchPoints = browserNavigator.maxTouchPoints ?? 0;
    const isIpadOsDesktopUa =
      browserNavigator.platform === IPAD_OS_DESKTOP_PLATFORM &&
      maxTouchPoints > 0;
    const hasHandheldUserAgent =
      ANDROID_USER_AGENT_REGEX.test(userAgent) ||
      IOS_USER_AGENT_REGEX.test(userAgent);
    const hasMobileFamilySignal =
      hasHandheldUserAgent || browserNavigator.userAgentData?.mobile === true;
    const hasTouchOrCoarseInput =
      maxTouchPoints > 0 ||
      this.matchesMedia('(pointer: coarse)') ||
      this.matchesMedia('(any-pointer: coarse)');

    return (
      isIpadOsDesktopUa || (hasMobileFamilySignal && hasTouchOrCoarseInput)
    );
  }

  private matchesMedia(query: string): boolean {
    if (typeof globalThis.matchMedia !== 'function') return false;
    return globalThis.matchMedia(query).matches;
  }
}
